import { useDropzone } from 'react-dropzone'
import { CloudUploadIcon } from '@heroicons/react/solid'

function Upload() {
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    const files = acceptedFiles.map(file => (
        <tr className>
            <td className="px-6 py-4">
                <div className="flex space-between">
                    <div>
                        <div className="mt-1 text-sm text-gray-600">
                            {file.path}
                        </div>
                    </div>
                </div>
            </td>
            <td className="px-6 py-4">
                <div className="mt-1 text-sm text-gray-600">
                    {formatBytes(file.size)}
                </div>
            </td>
        </tr>
    ));

    return (
        <section className="container">
            <div className="pt-4 pb-2">
                <div {...getRootProps({ className: 'dropzone mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md bg-gradient-to-r from-primary-50 to-secondary-50 cursor-pointer ' })}>
                    <input {...getInputProps()} />
                    <div className="space-y-1 text-center">
                        <CloudUploadIcon className="mx-auto h-12 w-12 text-gray-400" />
                        <div className="flex text-sm text-gray-600">
                            <label htmlFor="file-upload" className="relative cursor-pointer rounded-md">
                                <span className={"font-medium text-primary-600 hover:text-primary-600"}>Upload report</span>
                            </label>
                            <p className="pl-1">or drag and drop</p>
                        </div>
                        <p className="text-xs text-gray-500">Word or PDF preferred</p>
                    </div>
                </div>
            </div>
            <div className="mt-4">
                <div className={"overflow-hidden border-b border-none shadow-sm " +
                    "sm:rounded-lg"}
                >
                    <table className="table-fixed min-w-full">
                        <thead className="bg-blue-gray-50">
                            <tr>
                                <th scope="col" className="w-1/2 px-6 py-3 text-left text-xs font-medium text-blue-gray-500 uppercase font-mono tracking-wider">
                                    File
                                </th>
                                <th scope="col" className="w-1/2 px-6 py-3 text-left text-xs font-medium text-blue-gray-500 uppercase font-mono tracking-wider">
                                    Size
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {files.length === 0 ?
                                <tr>
                                    <td className="px-6 py-4">
                                        <div className="flex space-between">
                                            <div>
                                                <div className="text-sm text-blue-gray-500">
                                                    You haven't uploaded a report yet
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                :
                                files
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    )
}

export default Upload;